import React from "react";
import { SimpleCarousel, SectionTitle } from "tomo-react-components";
import CardContent from "./CardContent";
import { mobileDecorators } from "./decorators";
import styles from "../styles/carousel";
import data from "../data";

function FactsCarousel({}) {
  return (
    <div>
      <div style={styles.sectionTitleWrapper}>
        <SectionTitle.component
          wrapperCustomStyle={{ marginTop: "50px" }}
          title={["Some", <br />, "quick facts"]}
        />
      </div>
      <div style={styles.cardCarouselWrapper}>
        <SimpleCarousel.component
          autoplay={true}
          decorators={mobileDecorators}
          contents={data.cards}
        />
      </div>
      <div style={styles.sectionTitleWrapper}>
        <SectionTitle.component
          wrapperCustomStyle={{ marginTop: "50px" }}
          title={["Who shops on", <br />, "touch of", <br />, "modern?"]}
        />
      </div>
      <div style={styles.iconCardCarouselContainer}>
        <div style={styles.iconCardCarouselWrapper}>
          <SimpleCarousel.component
            autoplay={true}
            decorators={mobileDecorators}
            contents={data.iconCards.map((cardData, i) => {
              return {
                cardContent: (
                  <CardContent
                    iconName={cardData.iconName}
                    iconText={cardData.iconText}
                  />
                ),
                additionalText: cardData.additionalText,
              };
            })}
          />
        </div>
      </div>
    </div>
  );
}

export default FactsCarousel;
